/**
 * Sample data to fill the activityTypes table on creation
 *
 * colorId references colors from the Standard palette in colorPalettes table.
 * IDs 1-20 are available in the default palette.
 * iconName uses Solar icons via @iconify/vue (prefix: solar:)
 * Browse: https://icon-sets.iconify.design/solar/
 *
 * Standard palette color mapping:
 * 1=Red, 2=Pink, 3=Rose, 4=Orange, 5=Amber, 6=Yellow,
 * 7=Lime, 8=Green, 9=Emerald, 10=Teal, 11=Cyan, 12=Sky,
 * 13=Blue, 14=Indigo, 15=Violet, 16=Purple, 17=Fuchsia,
 * 18=Stone, 19=Zinc, 20=Slate
 */
const initialActivityTypesData = [
  {
    title: 'Biking',
    colorId: 1,  // Red
    iconName: 'solar:bicycling-linear'
  },
  {
    title: 'Walking',
    colorId: 4,  // Orange
    iconName: 'solar:walking-linear'
  },
  {
    title: 'Jogging',
    colorId: 5,  // Amber
    iconName: 'solar:running-2-linear'
  },
  {
    title: 'Hiking',
    colorId: 9,  // Emerald
    iconName: 'solar:hiking-linear'
  },
  {
    title: 'Swimming',
    colorId: 11, // Cyan
    iconName: 'solar:swimming-linear'
  },
  {
    title: 'Skating',
    colorId: 13, // Blue
    iconName: 'solar:skateboarding-linear'
  },
  {
    title: 'Rowing',
    colorId: 15, // Violet
    iconName: 'solar:routing-linear'
  }
];

export default initialActivityTypesData;
